<template>
    <div class="setting">
        <van-nav-bar
            title="设置"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="setting-box">
            <div class="setting-item flex-space-between">
                <p>头像</p>
                <div class="setting-item-right ">
                    <div class="setting-item-right-img">
                        <img :src="userInfo.headImage || require('../asset/images/userdefault.png')" >
                    </div>
                </div>
            </div>
            <div class="setting-item flex-space-between" @click="handleEdit">
                <p>昵称</p>
                <div class="setting-item-right align-items-center">
                    <p>{{userInfo.nickname}}</p>
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="setting-item flex-space-between">
                <p>电话</p>
                <div class="setting-item-right">
                    <p>{{getPhone()}}</p>
                </div>
            </div>
        </div>
        <div class="signOut" @click="handleSignOut">
            退出登录
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "setting",
    data(){
        return{
        }
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created(){
        
    },
    methods:{
        getPhone () {
            return sessionStorage.getItem("WdPhone") || ''
        },
        handleSignOut(){
            const params = {
                token: localStorage.getItem('token') || null
            }
            const frontendConfig  = sessionStorage.getItem('frontendConfig') ? JSON.parse(sessionStorage.getItem('frontendConfig')) : null
            this.$api.account.logout({ params }).then(res => {
                if(res.data){
                    // let path = null;
                    // path = frontendConfig && frontendConfig.filter(item => {
                    //     if(item.key === 'homepage'){
                    //         return true;
                    //     }
                    // })
                    /**
                     * 定制机构退出返回自己的首页
                     */
                    // const homePage = ['zhongzhi_homepage', 'gongxin_homepage','wanghong_homepage','housekeeping_homepage']
                    // if(path && path.length && homePage.includes(path[0].value)){
                    //     this.$router.push({
                    //         name:path[0].value
                    //     })
                    // }else {
                    //     window.location.replace({
                    //         name:'login'
                    //     })
                    // }
                    this.$router.push('gongxin_homepage')
                    localStorage.clear();
                    // sessionStorage.clear();
                    
                }else{
                    this.$toast('退出失败');
                }
            })
        },
        onClickLeft() {
            this.$router.go(-1);
        },
         handleEdit(){
           this.$router.push({
                path:"/edit",
             
            })
        }
    }
}
</script>
<style lang="stylus" scoped>
    .flex-space-between{
        display :flex;
        justify-content:space-between;
        align-items :center;
    }
    .align-items-center{
        display :flex;
        align-items :center;
    }
    .setting{
        height:100vh;
        background #F7F7F7
        position:relative;
        .signOut{
            width 100%
            height 100px
            background #fff
            margin-top 30px
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            text-align center
            line-height 100px
        }
        .setting-box{
            padding:0 30px;
            background #fff
            box-sizing :border-box;
        }
        .setting-item{
            padding:34px 0;
            border-bottom:1px solid #EAEAEA;
              p{
                    font-size:30px;
                }
            &:nth-child(1){
                padding:20px 0;
            }
            &:last-child {
                border-bottom 0
            }
            .setting-item-left{
                color:#333333;
            }
            .setting-item-right{
                .van-icon{
                    color:#666;
                    font-size :13px;
                }
                .setting-item-right-img{
                    width:100px;
                    height:100px;
                    border-radius:50%;
                    img{
                        width:100px;
                        height:100px;
                        border-radius:50%;
                    }
                }
                p{
                    color:#666;
                    font-size:26px;
                }
            }
        }
    }
</style>